import Text from './text';
import { map } from './utils';
import TextProvider, { TextContext, useText } from './provider';
import { Heading, Body, Tiny, Small, Large, Label, Bold, Semibold } from './components';
import { Truncate } from './truncate';
export { map, Text, TextProvider, TextContext, useText, Heading, Body, Tiny, Small, Large, Label, Bold, Semibold, Truncate };